// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/finance/${file}.vue`);

export default [
  // Journal
  {
    path: "/journals",
    name: "journals-list",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Journals",
    },
    components: {
      content: lazyLoad("journal-list"),
    },
  },
  // {
  //     path: "/journals/create",
  //     name: "journals-create",
  //     meta: {
  //         requiresAuth: true,
  //         applicationFeatureCode: "Journals",
  //     },
  //     components: {
  //         content: lazyLoad('journal'),
  //     },
  // },
  {
    path: "/journals/create*",
    name: "journals-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Journals",
    },
    components: {
      content: lazyLoad("journal-v2"),
    },
  },
  // {
  //     path: "/journals/review/:id",
  //     name: "journals-review",
  //     meta: {
  //         requiresAuth: true,
  //         applicationFeatureCode: "Journals",
  //     },
  //     components: {
  //         content: lazyLoad('journal'),
  //     },
  // },
  {
    path: "/journals/review/:id",
    name: "journals-review-v2",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Journals",
    },
    components: {
      content: lazyLoad("journal-v2"),
    },
  },
  // GLAccounts
  {
    path: "/gl-accounts",
    name: "gl-accounts",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "GlAccounts",
    },
    components: {
      content: lazyLoad("gl-account"),
    },
  },
  {
    path: "/gl-accounts/review/:id",
    name: "gl-accounts-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "GlAccounts",
    },
    components: {
      content: lazyLoad("gl-account"),
    },
  },
  {
    path: "/gl-accounts/edit/:id",
    name: "gl-accounts-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "GlAccounts",
    },
    components: {
      content: lazyLoad("gl-account"),
    },
  },
  {
    path: "/gl-accounts/create",
    name: "gl-accounts-Create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "GlAccounts",
    },
    components: {
      content: lazyLoad("gl-account"),
    },
  },

  // Bank Accounts
  {
    path: "/bank-accounts",
    name: "bank-accounts",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BankAccounts",
    },
    components: {
      content: lazyLoad("bank-account-list"),
    },
  },
  {
    path: "/bank-accounts/create",
    name: "bank-account",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BankAccounts",
    },
    components: {
      content: lazyLoad("bank-account"),
    },
  },
  {
    path: "/bank-accounts/review/:id",
    name: "bank-account-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BankAccounts",
    },
    components: {
      content: lazyLoad("bank-account"),
    },
  },
  {
    path: "/bank-accounts/edit/:id",
    name: "bank-account-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BankAccounts",
    },
    components: {
      content: lazyLoad("bank-account"),
    },
  },
  {
    path: "/bank-accounts-transaction/review/:id",
    name: "bank-account-transaction",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BankAccounts",
    },
    components: {
      content: lazyLoad("bank-account-transaction"),
    },
  },

  {
    path: "/bank-transactions",
    name: "bank-transactions",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BankTransactions",
    },
    components: {
      content: lazyLoad("bank-transactions-list"),
    },
  },

  {
    path: "/sundry-payment/:id",
    name: "sundry-payment",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BankTransactions",
    },
    components: {
      content: lazyLoad("sundry-payment"),
    },
  },

  {
    path: "/sundry-receipt/:id",
    name: "sundry-receipt",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BankTransactions",
    },
    components: {
      content: lazyLoad("sundry-receipt"),
    },
  },

  {
    path: "/bank-reconciliation/edit/:id",
    name: "bank-reconciliation-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BankReconciliation",
    },
    components: {
      content: lazyLoad("bank-reconciliation"),
    },
  },
];
